import UploadFileInput from 'components/uploadFile/uploadFileInput';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import api from 'api/call';
import UploadDisplay from 'components/uploadFile/UploadDisplay';
import usePrevious from 'hooks/usePrevious';
import { isEqual } from 'lodash';
import { toHalfWidthUnicode } from 'utility/general';

const SLayout = styled.div``;

const UploadWrapper = ({
    onFileUploadFinish = () => null,
    onLoadingChange = () => null,
    onUploadFailed = () => null,
    downloadType,
    name = '',
    label = '',
    files = [],
    inputStyle = false,
    multiple = false,
    onRawFileChange = (files) => null,
    enableRemove = false,
    enableDownload = false,
    onRemove = () => null,
    isRequired = false,
    isValidValue = (isValid) => null,
    disableOnPermission = false,
    inputStyleText,
    optional = false,
    disabled = false,
    buttonText = 'Upload',
    isLocalDownload = false,
    apiUrl,
    newRequestData,
}) => {
    const previousFiles = usePrevious(files);
    const [isFileUploading, setFileUploading] = useState(false);

    const onFileChange = async (list, params) => {
        try {
            let formData = new FormData();

            list.forEach((item) => {

                let file = item;

                try {
                    // convert the file name to all half width unicode for fix of code scan issue 
                    file = new File([item], toHalfWidthUnicode(item.name), {
                        type: item.type,
                    });
                } catch (error) {
                    console.log('%c 121359 PopupInput.jsx error', 'background: green', error)
                }

                formData.append('file', file);
            });

            setFileUploading(true);

            const res = await api.file.uploadDocument(formData);

            const serverResponse = res.data.result.result;

            const returnResult = [];

            serverResponse.forEach((item) => {

                const index = list.findIndex((listItem) => {
                    return listItem.name === item.fileName;
                });

                if (index !== -1) {
                    // returnResult
                    returnResult.push({ key: item.key, fileName: item.fileName, file: list[index] });
                }
            });

            onFileUploadFinish(returnResult);
            onRawFileChange(list);
            setFileUploading(false);
        } catch (error) {
            onUploadFailed(error);
            setFileUploading(false);
        }
    };

    useEffect(() => {
        onLoadingChange(isFileUploading);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFileUploading]);

    useEffect(() => {
        if (!isEqual(files, previousFiles)) {
            if (!isRequired) {
                return isValidValue(true);
            }

            if (files.length > 0) {
                return isValidValue(true);
            }

            isValidValue(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [files, isRequired]);

    return (
        <SLayout>
            {files.length > 0 ? (
                <UploadDisplay
                    fileList={files}
                    enableRemove={!disableOnPermission && enableRemove}
                    enableDownload={enableDownload}
                    downloadType={downloadType}
                    onRemove={onRemove}
                    apiUrl={apiUrl}
                    newRequestData={newRequestData}
                    isLocalDownload={isLocalDownload}
                />
            ) : (
                <UploadFileInput
                    multiple={multiple}
                    name={name}
                    optional={optional}
                    inputStyle={inputStyle}
                    inputStyleText={inputStyleText}
                    fileOnChange={onFileChange}
                    loading={isFileUploading}
                    label={label}
                    disableOnPermission={disableOnPermission}
                    disabled={disabled}
                    buttonText={buttonText}
                />
            )}
        </SLayout>
    );
};

export default UploadWrapper;
